export default {
  'getting_started.old.prepare_to_define_services_tutorial.define_status_check.paragraph':
    'Gremlin will work with your existing observability and monitoring tools to automatically halt tests that are causing your Service to fail. If you don’t have your monitors set up yet, we recommend setting up monitors that look at the Health Checks: latency, traffic, error rate, and resource saturation. Monitors are added during Service definition.',
  'getting_started.how_reliability_is_measured.title':
    'How will Reliability be measured?',
  'getting_started.how_reliability_is_measured.paragraph':
    "Reliability Scores are out of 100 points. There can be up to five categories (Scalability, Redundancy, Dependencies, Risks, and Other) that contribute to a Service's reliability.",

  // Onboarding
  'getting_started.getting_started_page.onboarding_type_select.introduction':
    "I'm getting started with",
  'getting_started.getting_started_page.onboarding_type_select.aws.label':
    'AWS',
  'getting_started.getting_started_page.onboarding_type_select.something_else.label':
    'Something Else',

  // AWS Onboarding Load Balancers
  'getting_started.aws_onboarding_load_balancers_page.tutorial_step_1.title':
    'Gremlin will use AWS Account {{awsAccountId}}',
  'getting_started.aws_onboarding_load_balancers_page.tutorial_step_2.before_fetch.title':
    "We're seeing how many Elastic Load Balancers (ELBs) we can map to a service you can start testing on.",
  'getting_started.aws_onboarding_load_balancers_page.tutorial_step_2.after_fetch.success.title':
    'Which of these ELBs should we turn into a testable service?',
  'getting_started.aws_onboarding_load_balancers_page.tutorial_step_2.after_fetch.empty_response.title':
    "Gremlin didn't see any Elastic Load Balancers (ELB) associated with this AWS account ID.",
  'getting_started.aws_onboarding_load_balancers_list.create_services.button.label':
    'Create {{numOfSelectedServices}} services',
  'getting_started.aws_onboarding_load_balancers_list.create_services.success.toast.message':
    'Services created',
  'getting_started.aws_onboarding_load_balancers_list.create_services.error.toast.message':
    'Failed to create services'
}
